<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5>Evaluaciones realizadas por el colaborador</h5>
      <b-button variant="primary" v-if="!adding && state == 'showing' && !deleted" @click="adding = true">Agregar</b-button>
    </div>

    <div class="row">
      <div class="col-md-4" v-if="adding">
        <div class="card mb-3">
          <div class="card-body">
            <form>
              <b-form-group label="Fecha de aplicación">
                <vue-ctk-date-time-picker v-model.lazy="newQuiz.date"
                  :only-date="true"
                  :no-button-now="true"
                  label=""
                  locale="es-us"
                  format="YYYY-MM-DD"
                  formatted="LL"
                  :auto-close="false"
                  :no-header="true"
                ></vue-ctk-date-time-picker>
              </b-form-group>
              <div class="card border-0 bg-ligth">
                <div class="card-body">
                  <b-row v-for="(quiz, index) in newQuiz.quizzes" :key="index">
                    <b-col md="8">
                      <b-form-group label="Evaluación">
                        <b-form-select v-model="quiz.quiz_id" :options="quizOptions"></b-form-select>
                      </b-form-group>
                    </b-col>
        
                    <b-col md="4">
                      <b-form-group label="Resultado">
                        <b-form-input v-model="quiz.result"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <b-button variant="info" outlined class="mr-2" @click="addQuiz">Agregar</b-button>
                <b-button variant="primary" outlined class="mr-2" @click="save">Guardar</b-button>
                <b-button variant="danger" outlined @click="cancel">Cancelar</b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-4" v-for="quizApplication in quizApplications" :key="quizApplication.id">
        <div class="card mb-3">
          <div class="card-body">
            <div class="card-title">{{ quizApplication.date }}</div>
            <b-list-group class="mb-3">
              <b-list-group-item v-for="quiz in quizApplication.quizzes" :key="`${quiz.id}-${quiz.pivot.quiz_application_id}`">
                <div class="d-flex justify-content-between">
                  <span class="text-primary">{{ quiz.area }}</span>
                  <b-badge variant="primary">{{ quiz.pivot.result }}</b-badge>
                </div>
              </b-list-group-item>
            </b-list-group>
            <div class="d-flex justify-content-end" v-if="state == 'showing'">
              <b-button variant="danger" @click="destroy(quizApplication.id)">Eliminar</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

export default {
  data() {
    return {
      adding: false,
      newQuiz: {
        date: null,
        quizzes: [{
          quiz_id: null,
          result: 0
        }]
      }
    }
  },
  components: {
    VueCtkDateTimePicker
  },
  computed: {
    ...mapState({
        quizzes: state => state.employeeManager.quizzes,
        employeeId: state => state.employeeManager.employee.id,
        quizApplications: state => state.employeeManager.employee.quizApplications,
        state: state=>state.employeeManager.state,
        deleted_at: state=>state.employeeManager.employee.deleted_at,
    }),
    quizOptions() {
      return [{ text: 'Elija una evaluación', value: null }].concat(this.quizzes.map(q => {
        return {
          text: q.area,
          value: q.id
        };
      }));
    },
    deleted() {
      return this.deleted_at !== null;
    }
  },
  methods: {
    ...mapActions(['getAndShowEmployee']),
    addQuiz() {
      this.newQuiz.quizzes.push({
        quiz_id: null,
        result: 0
      });
    },
    cancel() {
      this.adding = false;
      this.newQuiz = {
        date: null,
        quizzes: [{
          quiz_id: null,
          result: 0
        }]
      };
    },
    async save() {
      await axios.post(`/employees/${this.employeeId}/quizzes`, this.newQuiz).then(() => {
          this.cancel();
          this.getAndShowEmployee(this.employeeId);
      }).catch((e) => {
          if(e.response.data)
          {
              this.$store.dispatch('displayError', e.response.data.errors);
          }
          else
              this.$store.dispatch('displayError', ["Algo salió mal"]);

      });
    },
    async destroy(id) {
      await axios.delete(`/quiz-applications/${id}`);
      this.getAndShowEmployee(this.employeeId);
    }
  }
}
</script>
